import React, { useState } from 'react';

import CustomTh from '../shared/table/CustomTh';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import CompletedJobsItem from './CompletedJobsItem';
import useFilter from '../../utilities/useFilter';
import postData from '../../utilities/postData';
import Button from 'react-bootstrap/Button';
import PrintConfirmModal from './PrintConfirmModal';
import PagedListControl from '../shared/lists/PagedListControl';

const CompletedJobs = () => {
    const { items, setData, submitFilter, pageInfo } = useFilter('/api/dashboard/completedJobFollowUps', {}, true);

    const [showConfirm, setShowConfirm] = useState(false);

    function editItem(item) {
        const currentData = JSON.parse(JSON.stringify(items));
        const idx = currentData.findIndex(x => x.jobId === item.jobId);
        currentData[idx] = item;
        setData(currentData);
    }

    function selectAll({ target: { name, type, value, checked } }) {
        const currentData = JSON.parse(JSON.stringify(items));
        currentData.forEach((item) => {
            item[name] = checked;
        });
        setData(currentData);
    }

    const tableHead = (
        <thead>
            <tr>
                <CustomTh content="Customer" />
                <CustomTh width="85px" content="Date" />
                <CustomTh width="100px" className="text-center" content="Thank You" />
                <CustomTh width="100px" className="text-center" content="Satisfaction" />
            </tr>
        </thead>
    );

    const listItems = items && items.map((item) =>
        <CompletedJobsItem
            editItem={editItem}
            item={item}
            key={item.jobId}
        />);

    return (
        <div className="dashboard-container">
            <Col>
                <Row className="no-gutters">
                    <Col>
                        <div className="dashboard-follow-ups-title">Completed Jobs</div>
                    </Col>
                    <Col className="d-flex align-items-center justify-content-center" style={{ maxWidth: '100px' }}>
                        <label className="custom-control custom-checkbox d-inline-flex mb-0">
                            <input type="checkbox" className="custom-control-input" name="sendThankYou"
                                onChange={selectAll}
                            />
                            <span className="custom-control-label small" style={{ paddingTop: '.1em' }}>Select All</span>
                        </label>
                    </Col>
                    <Col className="d-flex align-items-center justify-content-center" style={{ maxWidth: '100px' }}>
                        <label className="custom-control custom-checkbox d-inline-flex mb-0">
                            <input type="checkbox" className="custom-control-input" name="sendSatisfaction"
                                onChange={selectAll}
                            />
                            <span className="custom-control-label small" style={{ paddingTop: '.1em' }}>Select All</span>
                        </label>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="fixed-table-head dashboard-follow-ups">
                            <Table striped size="sm">
                                {tableHead}
                                <tbody>
                                    {listItems}
                                </tbody>
                            </Table>
                            {(pageInfo.isFirstPage && pageInfo.isLastPage) ||
                                <PagedListControl {...pageInfo} />
                            }
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-end p-2">
                    <Col xs="auto">
                        <Button variant='info'
                            onClick={() => postData('/Followups/GetThankYouLetters', items, () => setShowConfirm(true), null, false)}
                        >Generate Follow-Ups</Button>
                    </Col>
                </Row>
            </Col>
            <PrintConfirmModal
                items={items}
                show={showConfirm}
                commitUrl={'/Followups/CommitThankYouLetters'}
                setShow={setShowConfirm}
                resetParent={submitFilter}
            />
        </div>
    );
}

export default CompletedJobs;